import React from 'react';
import { useNavigate } from 'react-router-dom';
import { soundManager } from '../utils/SoundManager';
import nativeAmericanFourTrainersData from '../data/NativeAmericanFour';
import './NativeAmericanFour.css';

const NativeAmericanFourTrainers = () => {
    const navigate = useNavigate();

    // Convert trainer data object to array
    const trainers = Object.values(nativeAmericanFourTrainersData);

    // Handle trainer selection
    const handleTrainerSelect = (trainer) => {
        console.log('🏔️ Native American Four trainer selected:', trainer.name);

        // 🎵 TRAINER SELECTION SOUND
        soundManager.playButtonSound();

        // Navigate to individual trainer page
        navigate(`/native-american-trainer/${trainer.id}`);
    };

    // Handle back navigation
    const handleBackToCategories = () => {
        soundManager.playButtonSound();
        navigate('/native-american-train-categories');
    };

    return (
        <div className="native-trainers-container">
            <div className="native-animated-background"></div>

            {/* Back Button */}
            <button
                className="back-to-categories-button"
                onClick={handleBackToCategories}
            >
                ← Back to Categories
            </button>

            {/* Header */}
            <div className="native-trainers-header">
                <div className="header-content">
                    <h1>Strategic Masters & Coastal Chiefs</h1>
                    <p>Train with legendary tacticians and mountain warriors</p>
                    <div className="category-stats">
                        <span className="stat-badge">Trainers: {trainers.length}</span>
                        <span className="stat-badge">Programs: {trainers.length * 6}</span>
                        <span className="stat-badge">Category: Strategic Nations</span>
                    </div>
                </div>
            </div>

            {/* Trainers Grid */}
            <div className="native-trainers-grid">
                {trainers.map((trainer, index) => (
                    <div
                        key={trainer.id}
                        className="native-trainer-card"
                        onClick={() => handleTrainerSelect(trainer)}
                        style={{
                            '--native-primary-color': trainer.color,
                            '--native-secondary-color': trainer.secondaryColor
                        }}
                    >
                        {/* Trainer Image */}
                        <div className="native-trainer-image-section">
                            <div
                                className="native-trainer-image"
                                style={{
                                    backgroundImage: `url(${trainer.image})`
                                }}
                            >
                                <div className="native-spirit-effect"></div>
                                <div className="experience-badge native-badge">
                                    {trainer.experience}
                                </div>
                            </div>
                        </div>

                        {/* Trainer Info */}
                        <div className="native-trainer-info-section">
                            <h3 className="native-trainer-name">{trainer.name}</h3>
                            <p className="native-trainer-specialization">{trainer.specialization}</p>
                            <p className="native-trainer-description">{trainer.intro}</p>

                            <div className="native-trainer-details">
                                <div className="detail-item native-detail">
                                    <div className="detail-icon">🏔️</div>
                                    <div className="detail-text">Programs: {trainer.programs.length}</div>
                                </div>
                                <div className="detail-item native-detail">
                                    <div className="detail-icon">🌊</div>
                                    <div className="detail-text">{trainer.experience}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Footer */}
            <div className="native-trainers-footer">
                <div className="native-info">
                    <h3>Strategic Masters & Coastal Chiefs Philosophy</h3>
                    <div className="native-benefits-grid">
                        <div className="native-benefit-item">
                            <div className="benefit-icon">🎯</div>
                            <div>
                                <strong>Strategic Brilliance</strong>
                                <p>Tactical genius and patient strategic thinking for military mastery</p>
                            </div>
                        </div>
                        <div className="native-benefit-item">
                            <div className="benefit-icon">⛰️</div>
                            <div>
                                <strong>Mountain Warfare</strong>
                                <p>High-altitude combat conditioning in challenging mountain terrain</p>
                            </div>
                        </div>
                        <div className="native-benefit-item">
                            <div className="benefit-icon">🌿</div>
                            <div>
                                <strong>Swamp Mastery</strong>
                                <p>Specialized wetland conditioning for unique environmental warfare</p>
                            </div>
                        </div>
                        <div className="native-benefit-item">
                            <div className="benefit-icon">🛡️</div>
                            <div>
                                <strong>Noble Sacrifice</strong>
                                <p>Leadership strength that accepts personal cost for the greater good</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NativeAmericanFourTrainers;